/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type InputTokensDetails = {
  cachedTokens: number;
};

/** @internal */
export const InputTokensDetails$inboundSchema: z.ZodType<
  InputTokensDetails,
  z.ZodTypeDef,
  unknown
> = z.object({
  cached_tokens: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "cached_tokens": "cachedTokens",
  });
});
/** @internal */
export type InputTokensDetails$Outbound = {
  cached_tokens: number;
};

/** @internal */
export const InputTokensDetails$outboundSchema: z.ZodType<
  InputTokensDetails$Outbound,
  z.ZodTypeDef,
  InputTokensDetails
> = z.object({
  cachedTokens: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    cachedTokens: "cached_tokens",
  });
});

export function inputTokensDetailsToJSON(
  inputTokensDetails: InputTokensDetails,
): string {
  return JSON.stringify(
    InputTokensDetails$outboundSchema.parse(inputTokensDetails),
  );
}
export function inputTokensDetailsFromJSON(
  jsonString: string,
): SafeParseResult<InputTokensDetails, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => InputTokensDetails$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'InputTokensDetails' from JSON`,
  );
}
